import React, {
  useState,
  useEffect,
  useRef,
} from "react";
import tokenomicsvid from "../../Assets/images/tokenomics.mp4";
import exbitlogo from "../../Assets/images/exbitlogo.webp";
import binance from "../../Assets/images/binance-smartchain.webp";
import copyicon from "../../Assets/images/copy.webp";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../Tokenomics/Tokenomics.css";
gsap.registerPlugin(ScrollTrigger);
const Tokenomics = () => {
  const videoRef = useRef(null);
  const scrollTriggerInstance = useRef(null);
  const [copySuccess, setCopySuccess] = useState(false);
  useEffect(() => {
    scrollTriggerInstance.current = ScrollTrigger.create({
      trigger: videoRef.current,
      start: "top center",
      end: "bottom center",
      onEnter: () => handlePlayFromStart(),
      onEnterBack: () => handlePlayFromStart(),
      markers: false,
    });
    return () => {
      if (scrollTriggerInstance.current) {
        scrollTriggerInstance.current.kill();
      }
    };
  }, []);
  const handlePlayFromStart = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      try {
        videoRef.current.play();
      } catch (error) {
        console.error("Video playback failed", error);
      }
    }
  };
  const handleCopy = () => {
    navigator.clipboard
      .writeText(contractAddress)
      .then(() => {
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000); // Reset after 2 seconds
      })
      .catch((error) => {
        console.error("Failed to copy contract address: ", error);
      });
  };
  const contractAddress = "0x3C9F96E704392863a8040E033014f44dA84FAcca";
  const shortenedAddress = `${contractAddress.slice(0, 4)}...${contractAddress.slice(-4)}`;
  return (
    <section
      id="tokenomicsSrl"
      className="tokenomics-section relative pt-5 md:pt-12 overflow-hidden"
    >
      <div className="container">
        <div className="mb-14 text-center">
          <span className="py-2 px-4 span-bx rounded-full text-md font-medium text-[#ffe400ba] text-center">
            Tokenomics
          </span>
          <h2 className="text-4xl text-center font-bold bg-gradient-to-br from-yellow-500 via-blue-500 to-yellow-400 text-transparent bg-clip-text py-3">
            ExBit'S Tokenomics
          </h2>
          <p className="text-lg font-normal text-gray-400 max-w-md md:max-w-5xl mx-auto">
            The Exbit token (EXB) is the lifeblood of the platform, driving
            transactions, rewards, and participation. Built on the Binance Smart
            Chain, EXB offers scalability and minimal transaction fees. Join
            the Exbit revolution and benefit from a token economy designed for
            sustainable growth.
          </p>
        </div>
        <div className="w-layout-blockcontainer tkncontainer mt-0 sm:mt-10 mx-auto max-w-6xl">
          <div className="w-container flex flex-wrap items-center justify-between tokenomics-wrapper py-0 sm:py-8 gap-y-8 px-0 md:px-2 lg:px-0">
            <div
              className="w-full md:w-1/2 tkntable flex justify-center"
              data-aos="fade-up"
              data-aos-duration="1600"
              data-aos-delay="200"
            >
              <div className="w-full relative">
                <div className="max-w-md token-table rounded-xl px-5 py-5 mx-auto md:mx-0">
                  <ul className="token-update__data list-unstyled">
                    <li>
                      <span>Token Name</span>
                      <strong className="text-blue-500 text-center">
                        <div className="flex gap-2 items-center">
                          <img
                            src={exbitlogo}
                            className="w-8 h-8"
                            alt="EXB Logo"
                          />
                          ExBit
                        </div>
                      </strong>
                    </li>
                    <li>
                      <span>Token Symbol</span>
                      <strong className="text-blue-500 text-center">EXB</strong>
                    </li>
                    <li>
                      <span>Tokens Supply</span>
                      <strong className="text-blue-500 text-center">500,000,000 EXB</strong>
                    </li>
                    <li>
                      <span>Blockchain</span>
                      <strong className="text-blue-500 text-center">
                        Binance Smart Chain
                      </strong>
                    </li>
                    <li>
                      <span>Contract Address</span>
                      <strong className="text-blue-500 text-center">
                        <div
                          className="flex items-center copy-icon-div gap-2"
                          id="contract-address"
                        >
                          <a
                            href={`https://bscscan.com/token/${contractAddress}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline text-blue-500"
                          >
                            {shortenedAddress}
                          </a>
                          <img
                            src={copyicon}
                            height={100}
                            width={100}
                            className="w-5 h-5 copy-icon cursor-pointer ml-1"
                            alt="copyicon"
                            onClick={handleCopy}
                          />
                        </div>
                      </strong>
                      {copySuccess && (
                        <div
                          className="absolute bottom-10 right-5 bg-blue-500 text-yellow-400      text-sm py-2 px-4 rounded shadow-lg"
                        >
                          Address copied!
                        </div>
                      )}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="w-full md:w-1/2"
              data-aos="fade-up"
              data-aos-duration="1800"
              data-aos-delay="200"
            >
              <div ref={videoRef} className="tokenimg">
                <video
                  className="tknimg2"
                  ref={videoRef}
                  src={tokenomicsvid}
                  alt="Token Distribution"
                  width="100%"
                  height="100%"
                  muted
                  playsInline
                  autoPlay
                  loop
                  style={{ opacity: 1 }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section_about-bg-gradient animate-pulse" />
    </section>
  );
};
export default Tokenomics;